import { atom } from 'jotai'
import { SelectionAddonTabs } from '~/components/quick-checkout/QuickCheckout.config'

export const selectionAddonTabAtom = atom<keyof typeof SelectionAddonTabs>(SelectionAddonTabs.selection)
